import { defineStyleConfig } from '@chakra-ui/styled-system';
import { sizes as sizes$1, baseStyle as baseStyle$1, defaultProps } from './input.js';

const sizes = {
  xl: {
    ...sizes$1.xl,
    field: {
      ...sizes$1.xl.field,
      // &.chakra-select selector is for mobile select component built with Chakra-ui
      "&.chakra-select": {
        paddingRight: "2.5rem"
      }
    },
    icon: sizes$1.lg.field
  },
  lg: {
    ...sizes$1.lg,
    field: {
      ...sizes$1.lg.field,
      // &.chakra-select selector is for mobile select component built with Chakra-ui
      "&.chakra-select": {
        paddingRight: "2rem",
        paddingY: ".375rem"
      }
    },
    icon: sizes$1.md.field
  },
  md: {
    ...sizes$1.md,
    field: {
      ...sizes$1.md.field,
      // &.chakra-select selector is for mobile select component built with Chakra-ui
      "&.chakra-select": {
        paddingRight: "2rem"
      }
    },
    icon: sizes$1.md.field
  },
  sm: {
    ...sizes$1.sm,
    field: {
      ...sizes$1.sm.field,
      // &.chakra-select selector is for mobile select component built with Chakra-ui
      "&.chakra-select": {
        paddingY: "1px",
        paddingRight: "2rem"
      }
    },
    icon: sizes$1.sm.field
  },
  xs: {
    ...sizes$1.xs,
    field: {
      ...sizes$1.xs.field,
      // &.chakra-select selector is for mobile select component built with Chakra-ui
      "&.chakra-select": {
        paddingRight: "1.875rem",
        paddingY: "1px"
      }
    },
    icon: sizes$1.xs.field
  }
};
const baseStyle = {
  ...baseStyle$1,
  field: {
    ...baseStyle$1.field,
    cursor: "pointer",
    WebkitAppearance: "none",
    MozAppearance: "none",
    bgColor: "transparent",
    // This span is the `SelectValueText` component that targets the text that's wrapped in a button.
    span: {
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap"
    }
  },
  "::-ms-expand": {
    display: "none"
  },
  textTransform: "none",
  icon: {
    fontWeight: "bold",
    position: "absolute",
    right: "0.5rem",
    fontSize: "var(--input-font-size)",
    // With SelectMobile we're defaulting to the Chevron SVG that Chakra renders -
    // which has a height and width set at 1em.
    // In our custom ArkUI Select the icon height and width are derived,
    // so this ensures those styles get applied correctly so our desktop and mobile select input look consistent across devices.
    svg: {
      height: "var(--icon-height)!important",
      width: "var(--icon-width)!important"
    }
  }
};
const Select = defineStyleConfig({
  baseStyle,
  sizes,
  // @ts-ignore - Added 'status' property, not a default Chakra prop, a convention from Iris
  defaultProps
});

export { Select };
